/**
 * Statuts d’intérêt (shares/{token}/interests) où l’adresse réelle peut remplacer l’aperçu anonymisé
 * (carte « Partagés avec moi », vue lien partagé, etc.).
 */
const ADDRESS_VISIBLE_INTEREST_STATUSES = new Set([
  'document_access_granted',
  'interest_confirmed',
  'cession_submitted',
]);

export function interestUnlocksSharedAddress(status) {
  return !!status && ADDRESS_VISIBLE_INTEREST_STATUSES.has(status);
}
